import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default function initFlashConnect(connect) {
  return function flashConnect(activeViewId, viewName) {
    return (component) => {
      class flashConnectComponent extends Component {
        static propTypes = {
          setActiveViewId: PropTypes.func.isRequired,
          resetFlashView: PropTypes.func.isRequired,
          registerUnmountCleanupMethod: PropTypes.func,
        };

        static defaultProps = {
          registerUnmountCleanupMethod: null,
        };

        constructor(props) {
          super(props);

          props.setActiveViewId(activeViewId);

          if (props.registerUnmountCleanupMethod) {
            props.registerUnmountCleanupMethod(() => {
              props.resetFlashView({ from: viewName });
            });
          }
        }

        render() {
          return React.createElement(component, { ...this.props, activeFlashId: activeViewId });
        }
      }

      return connect(flashConnectComponent);
    };
  };
}
